import React, { useEffect, useState } from "react";
import {
	Grid,
	Typography,
	Button,
	TextField,
	MenuItem,
	Table,
	TableBody,
	TableCell,
	TableContainer,
	TableHead,
	TableRow,
	Paper,
	TablePagination,
	Dialog,
	DialogActions,
	DialogContent,
	DialogContentText,
	DialogTitle,
	FormControl,
	Hidden,
	Box, IconButton, InputLabel, Input, InputAdornment
} from "@mui/material";
// import PhoneInput from "react-phone-input-2";
// import { makeStyles } from "@mui/styles";
import Layout from "../../components/Wrappers/Layout";
import {
	Card,
	Alert,
	Row,
	Col,
	CardTitle,
	CardHeader,
	FormGroup
} from "reactstrap";
import Autocomplete from "@mui/lab/Autocomplete";
import { createFilterOptions } from "@mui/material";
// import Autocomplete, {
// 	createFilterOptions
// } from "@mui/material/lab/Autocomplete";
import { AiOutlineSearch } from "react-icons/ai";
import { AiOutlineUserAdd } from "react-icons/ai";
import { AiOutlineFileAdd } from "react-icons/ai";
import { NavLink, Link, useHistory, useNavigate } from "react-router-dom";
import { Route, useLocation } from "react-router-dom";
import { useSelector, useDispatch } from "react-redux";
import { countries } from "../../utils/countriesDropdown";
import success from "../../assets/img/success.png";
import failed from "../../assets/img/failed.png";
import LoadingSpinner from "../../components/LoadingSpinner/LoadingSpinner";
import CustomButton from "../../components/CustomButton/CustomButton";
import CommonLogout from "../../components/CommonLogout/CommonLogout";
import { createOrUpdateWalletOwner } from "../../redux/actions/createOrUpdateWalletOwnerAction";
import { getThemeList } from "../../redux/actions/getThemeListAction";
// import IconButton from "@mui/material/IconButton";
// import InputLabel from "@mui/material/InputLabel";
// import Visibility from "@mui/icons-material/Visibility";
// import InputAdornment from "@mui/material/InputAdornment";
// import VisibilityOff from "@mui/icons-material/VisibilityOff";
// import Input from "@mui/material/Input";
import BackButton from "../../components/BackButton/BackButton";
import FileBase64 from "../../components/Upload/UploadFile";
import Util from "../../validation/index";
import regenerateToken from "../../components/RegenerateToken/regenerateToken";
import SOLogout from "../../components/Logout/SOLogout";
import PhoneInput from "react-phone-input-2";
import val from "../../getThemeDetails";

const AdminAddWalletOwner = () => {
	const navigate = useHistory();
	// const partnerloginUser = useSelector(({ login }) => login);
	// var authToken = partnerloginUser.data.AuthToken;
	const regenerateTokenRes = useSelector(
		({ regenerateToken }) => regenerateToken
	);
	var authToken = regenerateTokenRes.data.AuthToken;

	const dispatch = useDispatch();

	const createWalletRes = useSelector(
		({ createOrUpdateWalletOwner }) => createOrUpdateWalletOwner
	);

	const themeList = useSelector(({ getThemeList }) => getThemeList);

	//Consent (Transaction and Sign Up)
	const [getSignUpConsent, setGetSignUpConsent] = useState('');
	const [getTransactionConsent, setGetTransactionConsent] = useState('')
	const [twoFactorAuthen, setTwoFactorAuthen] = useState("");




	const [formData, setFormData] = useState({
		walletOwnerName: "",
		userName: "",
		password: "",
		confirmPassword: "",
		email: "",
		mobile: "",
		address: "",
		country: "",
		website: "",
		organizationName: "",
		contactPerson: "",
		walletOwnerHostURL: "",
		customerMerchantHostURL: "",
		supportURL: "",
		applyPrepaidSignUp: "Y",
		fraudCheckAllow: "Y",
		emailAllow: "Y",
		smsAllow: "Y",
		emailOTPSignUp: "Y",
		smsOTPSignUp: "Y",
		walletRequired: "Y",
		voucherRequired: "N",
		template: "Y",
		currentTheme: "",
		expiryDays: "",
		allowRefund: "N",
		isCustomAmtAllowed: "N",
		minVoucherAmt: "N",
		invoiceRequired: 'Y',
		openBankingRequired: 'Y',
		twitterUrl: '',
		instagramUrl: '',
		facebookUrl: '',

		// signupConsent: '',
		// transactionConsent: ''

	});

	// Object Destructuring
	const {
		walletOwnerName,
		userName,
		password,
		confirmPassword,
		email,
		mobile,
		address,
		country,
		website,
		organizationName,
		contactPerson,
		walletOwnerHostURL,
		customerMerchantHostURL,
		supportURL,
		applyPrepaidSignUp,
		fraudCheckAllow,
		emailAllow,
		smsAllow,
		emailOTPSignUp,
		smsOTPSignUp,
		walletRequired,
		voucherRequired,
		template,
		currentTheme,
		expiryDays,
		allowRefund,
		isCustomAmtAllowed,
		minVoucherAmt,
		invoiceRequired,
		openBankingRequired,
		twitterUrl,
		instagramUrl,
		facebookUrl,

		// signupConsent,
		// transactionConsent

	} = formData;

	// const onInputChange = ({ target: { name, value } }) => {
	//   const inputChangeObj = { ...formData }
	//   inputChangeObj[name] = value
	//   setFormData(inputChangeObj);
	// }

	const onInputChange = ({ target: { name, value } }, type, companyLogo) => {
		// setFormData({ ...formData, [e.target.name]: e.target.value });
		const obj = {
			...formData
		};

		if (type == "number") {
			obj[name] = Util.verifyMobile(value) ? value : obj[name];
		} else if (type == "alphabet") {
			obj[name] = Util.verifyAlphabet(value) ? value : obj[name];
		} else if (type == "both") {
			obj[name] = Util.alphaNumeric(value) ? value : obj[name];
		} else if (type == "password") {
			obj[name] = Util.verifyPassword(value) ? value : obj[name];
		}
		// else if (type == "email") {
		//   obj[name] = Util.verifyEmail(value) ? value : obj[name];
		// }
		else if (type == "address") {
			obj[name] = Util.verifyAddress(value) ? value : obj[name];
		} else {
			// obj[name] = value.trim()
			obj[name] = Util.noWhiteSpace(value) ? value : obj[name];
		}
		setFormData(obj);
	};

	const handleChange = ({ target: { name, value } }) => {
		//Consent (Sign up and Transaction)
		if (name === 'getSignUpConsent') {
			setGetSignUpConsent(value);
		}
		if (name === 'getTransactionConsent') {
			setGetTransactionConsent(value);
		}
		if (name === "twoFactorAuthen") {
			setTwoFactorAuthen(value);
		}
	}

	const [companyLogoNameImg, setCompanyLogoNameImg] = useState("");
	const [companyLogoName, setCompanyLogoName] = useState("");
	const [uploadIcon, setUploadIcon] = useState("");
	const [uploadIconImg, setUploadIconImg] = useState("");

	const handleAttachmentsDoc = (e, companyLogo) => {
		if (companyLogo == "companyLogo") {
			setCompanyLogoNameImg(e.base64);
			setCompanyLogoName(e.name);
		} else if (companyLogo == "uploadIcon") {
			setUploadIconImg(e.base64.substring(e.base64.indexOf(',') + 1));
			setUploadIcon(e.name);
		}
	};

	const [addWalletStatus, setAddWalletStatus] = useState(false);
	const [addOrUpdateCreateWalletArray, setAddOrUpdateCreateWalletArray] =
		useState([]);

	const [notificationOpen, setNotificationOpen] = React.useState(false);

	const [themeStatus, setThemeStatus] = useState(false);

	const addWalletOwnerRequest = () => {
		setAddWalletStatus(true);
		const addWalletOwnerReq = {
			loginDetails: {
				walletOwnerId: "",
				// adminId: 2
				adminId:val.adminIDS
			},
			ownerMasterRequestVO: {
				ownerName: walletOwnerName,
				userName: userName,
				password: password,
				confirmPassword: confirmPassword,
				email: email,
				mobile: phoneDetails.rawNumber,
				dialCode:phoneDetails.dialCode,
				address: address,
				country: country,
				website: website,
				organization: organizationName,
				contactPerson: contactPerson,
				hostURL: customerMerchantHostURL,
				ownhostURL: walletOwnerHostURL,
				supportURL: supportURL,
				companyLogo: companyLogoNameImg,
				iconBase64: uploadIconImg,
				isPrepaidCard: applyPrepaidSignUp == "Y" ? "1" : "0",
				isFraudCheck: fraudCheckAllow == "Y" ? "1" : "0",
				isEmailAllowed: emailAllow == "Y" ? "1" : "0",
				isSMSAllowed: smsAllow == "Y" ? "1" : "0",
				isEmailOtp: emailOTPSignUp == "Y" ? "1" : "0",
				isSMSOtp: smsOTPSignUp == "Y" ? "1" : "0",
				isWallet: walletRequired == "Y" ? "Y" : "N",
				isVoucher: voucherRequired == "N" ? "N" : "Y",
				isTemplate: template == "Y" ? "1" : "0",
				currentTheme: currentTheme,
				expiryDays: expiryDays,
				allowRefund: allowRefund == "N" ? "N" : "Y",
				isCustomAmtAllowed: isCustomAmtAllowed == "N" ? "N" : "Y",
				minVoucherAmt: minVoucherAmt == "N" ? "N" : "Y",
				invoiceRequired: invoiceRequired,
				openBankingRequired: openBankingRequired,
				twitterUrl: twitterUrl,
				instagramUrl: instagramUrl,
				facebookUrl: facebookUrl,
				signupConsent: getSignUpConsent,
				transactionConsent: getTransactionConsent,
				twoFactorGoogle: twoFactorAuthen
			}
		};
		dispatch(createOrUpdateWalletOwner(addWalletOwnerReq, authToken));
	};

	const addOrUpdateCreateWalletFunc = () => {
		if (addWalletStatus) {
			if (createWalletRes.data.status == "success") {
				setAddOrUpdateCreateWalletArray(createWalletRes.data);
				setNotificationOpen(true);
			}
			if (createWalletRes.data.status == "failed") {
				setAddOrUpdateCreateWalletArray(createWalletRes.data);
				setNotificationOpen(true);
				if (
					createWalletRes.data.description == "session out"
				) {
					SOLogout(dispatch, authToken, regenerateTokenRes.data.partnerId);
				}
				if (
					createWalletRes.data.description == "Authorization failed"
				) {
					regenerateToken(dispatch, authToken, regenerateTokenRes.data.partnerId);
				}
			}
		}
	};

	useEffect(() => {
		addOrUpdateCreateWalletFunc();
	}, [createWalletRes.data.status]);

	// useEffect(() => {
	//   if (addWalletStatus) {
	//     if (createWalletRes.data.status == "Success") {
	//       setAddWalletStatus(createWalletRes.data.status);
	//       // setNotificationOpen(true);
	//     }
	//     if (createWalletRes.data.status == "failed") {
	//       setAddWalletStatus(createWalletRes.data.status);
	//       // setNotificationOpen(true);
	//     }
	//     if (createWalletRes.data.status == "Failed") {
	//       setAddWalletStatus(createWalletRes.data.status);
	//       // setNotificationOpen(true);
	//     }
	//   }
	// }, [createWalletRes.data.status]);

	// Curent Theme
	const currentThemeRequest = () => {
		// setAddWalletStatus(true);

		const currentThemeReq = {
			loginDetails: {
				// adminId: "2"
				adminId:val.adminIDS
			}
		};
		dispatch(getThemeList(currentThemeReq, authToken));
	};

	useEffect(() => {
		if (regenerateTokenRes.data.status == "success") {
			currentThemeRequest();
		}
	}, [regenerateTokenRes.data.AuthToken]);

	const submitClick = () => {
		addWalletOwnerRequest();
	};

	useEffect(() => {
		if (themeStatus) {
			if (themeList.data.status == "Success") {
				setThemeStatus(themeList.data.status);
				setNotificationOpen(true);
			}
			if (themeList.data.status == "failed") {
				setThemeStatus(themeList.data.status);
				setNotificationOpen(true);
				if (
					themeList.data.description == "session out"
				) {
					SOLogout(dispatch, authToken, regenerateTokenRes.data.partnerId);
				}
				if (
					themeList.data.description == "Authorization failed"
				) {
					regenerateToken(dispatch, authToken, regenerateTokenRes.data.partnerId);
				}
			}
			if (themeList.data.status == "Failed") {
				setThemeStatus(themeList.data.status);
				setNotificationOpen(true);
				if (
					themeList.data.description == "session out"
				) {
					SOLogout(dispatch, authToken, regenerateTokenRes.data.partnerId);
				}
				if (
					themeList.data.description == "Authorization failed"
				) {
					regenerateToken(dispatch, authToken, regenerateTokenRes.data.partnerId);
				}
			}
		}
	}, [themeList.data.status]);

	const handleNoticationClose = () => {
		setNotificationOpen(false);
		if (addOrUpdateCreateWalletArray.status == "success") {
			navigate.push("/index/create-wallet-owner");
		}
		setFormData({
			walletOwnerName: "",
			userName: "",
			password: "",
			confirmPassword: "",
			email: "",
			mobile: "",
			address: "",
			country: "",
			website: "",
			organizationName: "",
			contactPerson: "",
			walletOwnerHostURL: "",
			customerMerchantHostURL: "",
			supportURL: "",
			applyPrepaidSignUp: "Y",
			fraudCheckAllow: "Y",
			emailAllow: "Y",
			smsAllow: "Y",
			emailOTPSignUp: "Y",
			smsOTPSignUp: "Y",
			walletRequired: "Y",
			voucherRequired: "N",
			template: "Y",
			currentTheme: "",
			expiryDays: "",
			allowRefund: "N",
			isCustomAmtAllowed: "N",
			minVoucherAmt: "N",
			// signupConsent: "",
			// transactionConsent: ""
		});
	};

	const filterOptions = createFilterOptions({
		matchFrom: "any",
		limit: 500
	});

	// password eye

	// const [password, setPassword] = React.useState({
	//   password: "",
	//   showPassword: false,
	// });

	// const handleClickShowPassword = () => {
	//   setPassword({ ...password, showPassword: !password.showPassword });
	// };

	// const handleMouseDownPassword = (event) => {
	//   event.preventDefault();
	// };

	// const handlePasswordChange = (prop) => (event) => {
	//   setPassword({ ...password, [prop]: event.target.value });
	// };
  const [phoneDetails, setPhoneDetails] = useState({
    fullNumber: "",
    dialCode: "",
    rawNumber: "",
    countryCode: "",
  });
    const handleContact = (value, data, event, formattedValue) => {
    // 'value' is the full number including dial code (e.g., "919870029898")
    // 'data' contains object with dialCode, name, countryCode
    // 'formattedValue' is the formatted number (e.g., "+91 98700 29898")

    const { dialCode, countryCode } = data;
    const rawNumber = value.startsWith(dialCode) ? value.substring(dialCode.length) : value;

    setPhoneDetails({
      fullNumber: value,
      dialCode: dialCode,
      rawNumber: rawNumber,
      countryCode: countryCode,
    });

    setFormData((state) => ({
      ...state,
      phoneNumber: value, // Keep this for display if needed
      countryCode: dialCode, // This is not used in the API call for mobile, but might be for 'country_code'
      country: countryCode, // ISO country code (e.g., "in")
    }));
  };
	return (
		<>
			<Layout>
				<BackButton />
				<Card>
					<Grid container>
						<Grid item lg={2} md={2}>
							{/* <Button
                onClick={IndividualE}
                startIcon={<IoIosArrowBack />}
                variant="text"
                color="primary"
              >
                Go Back
              </Button> */}
						</Grid>
						<Grid item lg={10} md={10}></Grid>
					</Grid>

					<br />
					<Grid container>
						<Grid item xs={12} lg={12} md={12} sm={12}>
							<h6
								align="center"
								className="text-center themeText"
							// style={{ marginTop: "1.2rem", marginRight: "3rem" }}
							>
								{" "}
								Owner Information
							</h6>
						</Grid>
					</Grid>

					<Grid container style={{ padding: "10px" }}>
						<Grid item xs={12} md={2} lg={2}></Grid>

						<Grid item xs={12} md={8} lg={8}>
							<div style={{ marginTop: "1.5rem" }}>
								{" "}
								<FormGroup>
									<FormControl fullWidth>
										<TextField
											required
											size="small"
											color="primary"
											autoFocus={true}
											label="Owner Name"
											fullWidth={true}
											variant="standard"
											name="walletOwnerName"
											value={walletOwnerName || ""}
											// onChange={(e) => onInputChange(e)}
											onChange={(e) => onInputChange(e, "alphabet")}
											InputProps={{
												sx: {
													"&:before": { borderBottomColor: "gray" }, // before focus
													"&:after": { borderBottomColor: "gray" },  // after focus
												},
											}}
											InputLabelProps={{
												sx: { color: 'gray' }, // Optional: if you want the label to be white
											}}
										/>
									</FormControl>
								</FormGroup>
							</div>
							<div style={{ marginTop: "1.5rem" }}>
								<TextField
									required
									size="small"
									color="primary"
									autoFocus={true}
									label="UserName"
									fullWidth={true}
									name="userName"
									variant="standard"

									value={userName || ""}
									// onChange={(e) => onInputChange(e)}
									onChange={(e) => onInputChange(e, "alphabet")}
									InputProps={{
										sx: {
											"&:before": { borderBottomColor: "gray" }, // before focus
											"&:after": { borderBottomColor: "gray" },  // after focus
										},
									}}
									InputLabelProps={{
										sx: { color: 'gray' }, // Optional: if you want the label to be white
									}}
								/>
							</div>
							<div style={{ marginTop: "1.5rem" }}>
								{" "}
								<FormGroup>
									<FormControl fullWidth>
										<TextField
											required
											helperText="(Passwords length should be at least 8 and should contain alphabet, numeric, and special characters like !@#$)"
											type="password"
											size="small"
											color="primary"
											autoFocus={true}
											label="Password"
											variant="standard"

											fullWidth={true}
											name="password"
											// id="lastName"
											value={password}
											onChange={(e) => onInputChange(e)}
										/>
										{/* <Input
                      required
                      helperText="(Passwords length should be at least 8 and should contain alphabet, numeric, and special characters like !@#$)"
                      type={password.showPassword ? "text" : "password"}
                      onChange={handlePasswordChange("password")}
                      value={password.password}
                      endAdornment={
                        <InputAdornment position="end">
                          <IconButton
                            onClick={handleClickShowPassword}
                            onMouseDown={handleMouseDownPassword}
                          >
                            {password.showPassword ? <Visibility /> : <VisibilityOff />}
                          </IconButton>
                        </InputAdornment>
                      }
                    /> */}
									</FormControl>
								</FormGroup>
							</div>
							<div style={{ marginTop: "1.5rem" }}>
								{" "}
								<FormGroup>
									<FormControl fullWidth>
										<TextField
											required
											helperText="(Should be same as PASSWORD)"
											type="password"
											size="small"
											color="primary"
											autoFocus={true}
											variant="standard"

											label="Confirm Password"
											fullWidth={true}
											name="confirmPassword"
											// id="lastName"
											value={confirmPassword}
											InputProps={{
												sx: {
													"&:before": { borderBottomColor: "gray" }, // before focus
													"&:after": { borderBottomColor: "gray" },  // after focus
												},
											}}
											InputLabelProps={{
												sx: { color: 'gray' }, // Optional: if you want the label to be white
											}}
											onChange={(e) => onInputChange(e, "")}
											error={
												password &&
													password !== confirmPassword &&
													confirmPassword ? (
													<p
														className="passwordNotMatch"
														style={{ color: "red" }}
													>
														{"Password did not match"}
													</p>
												) : (
													""
												)
											}
										/>
									</FormControl>
								</FormGroup>
							</div>
							<div style={{ marginTop: "1.5rem" }}>
								{" "}
								<FormGroup>
									<FormControl fullWidth>
										<TextField
											required
											size="small"
											color="primary"
											autoFocus={true}
											variant="standard"

											label="Email"
											placeholder="abc@gmail.com"
											fullWidth={true}
											name="email"
											value={email || ""}
											onChange={(e) => onInputChange(e, "email")}
											InputProps={{
												sx: {
													"&:before": { borderBottomColor: "gray" }, // before focus
													"&:after": { borderBottomColor: "gray" },  // after focus
												},
											}}
											InputLabelProps={{
												sx: { color: 'gray' }, // Optional: if you want the label to be white
											}}
										/>
									</FormControl>
								</FormGroup>
							</div>
							<div style={{ marginTop: "1.5rem" }}>
								{" "}
								<FormGroup>
									<FormControl fullWidth>
										<PhoneInput
											autoFormat={true}
											enableSearch={true}
											onChange={handleContact}
											// value={phoneNumber}
											value={phoneDetails.fullNumber}
											onlyCountries={val.onlyCountries}
											required
											size="small"
											color="primary"
											autoFocus={true}
											label="Mobile"
										/>
										{/* <TextField
											required
											size="small"
											color="primary"
											autoFocus={true}
											label="Mobile"
											variant="standard"
											fullWidth={true}
											name="mobile"
											value={mobile || ""}
											// onChange={(e) => onInputChange(e)}
											onChange={(e) => onInputChange(e, "number")}
											InputProps={{
												sx: {
												  "&:before": { borderBottomColor: "gray" }, // before focus
												  "&:after": { borderBottomColor: "gray" },  // after focus
												},
											  }}
											  InputLabelProps={{
												sx: { color: 'gray' }, // Optional: if you want the label to be white
											  }}
										/> */}
									</FormControl>
								</FormGroup>
							</div>
							<div style={{ marginTop: "1.5rem" }}>
								{" "}
								<FormGroup>
									<FormControl fullWidth>
										<TextField
											required
											size="small"
											color="primary"
											variant="standard"

											autoFocus={true}
											label="Address"
											fullWidth={true}
											name="address"
											value={address || ""}
											onChange={(e) => onInputChange(e, "both")}
											InputProps={{
												sx: {
													"&:before": { borderBottomColor: "gray" }, // before focus
													"&:after": { borderBottomColor: "gray" },  // after focus
												},
											}}
											InputLabelProps={{
												sx: { color: 'gray' }, // Optional: if you want the label to be white
											}}
										/>
									</FormControl>
								</FormGroup>
							</div>
							<div style={{ marginTop: "1.5rem" }}>
								{" "}
								<Autocomplete
									id="combo-box-demo"
									options={[].concat(countries)}
									getOptionLabel={(option) => option.label}
									filterOptions={filterOptions}
									renderInput={(params) => (
										<TextField
											required
											margin="dense"
											id="name"
											size="small"
											variant="standard"

											color="primary"
											type="text"
											label="Country"
											style={{ marginTop: "0" }}
											{...params}
											fullWidth={true}
											name="country"
											value={country || ""}
											onBlur={onInputChange}
											InputProps={{
												sx: {
													"&:before": { borderBottomColor: "gray" }, // before focus
													"&:after": { borderBottomColor: "gray" },  // after focus
												},
											}}
											InputLabelProps={{
												sx: { color: 'gray' }, // Optional: if you want the label to be white
											}}
										></TextField>
									)}
								/>
								{/* <TextField
                  select
                  size="small"
                  color="primary"
                  autoFocus={true}
                  type="string"
                  label="Country"
                  fullWidth={true}
                  name="country"
                  value={country || "Select Country"}
                  onChange={(e) => onInputChange(e)}
                >
                  <MenuItem value="Select Country">Select Country</MenuItem>
                  {countries.map((value) => (
                    <MenuItem value={value.label}>{value.label}</MenuItem>
                  ))} */}
								{/* <MenuItem value="India">India</MenuItem>
                  <MenuItem value="USA">USA</MenuItem>
                  <MenuItem value="England">England</MenuItem> */}
								{/* </TextField> */}
							</div>
							<div style={{ marginTop: "1.5rem" }}>
								{" "}
								<FormGroup>
									<FormControl fullWidth>
										<TextField
											type="website"
											required
											size="small"
											placeholder="www.paymentz.com"
											color="primary"
											label="Website"
											variant="standard"

											autoFocus={true}
											fullWidth={true}
											name="website"
											id="website"
											value={website || ""}
											onChange={(e) => onInputChange(e)}
											InputProps={{
												sx: {
													"&:before": { borderBottomColor: "gray" }, // before focus
													"&:after": { borderBottomColor: "gray" },  // after focus
												},
											}}
											InputLabelProps={{
												sx: { color: 'gray' }, // Optional: if you want the label to be white
											}}
										/>
									</FormControl>
								</FormGroup>
							</div>
							<div style={{ marginTop: "1.5rem" }}>
								{" "}
								<FormGroup>
									<FormControl fullWidth>
										<TextField
											type="organizationName"
											size="small"
											color="primary"
											label="Organization Name"
											autoFocus={true}
											variant="standard"

											fullWidth={true}
											name="organizationName"
											id="organizationName"
											value={organizationName || ""}
											// onChange={(e) => onInputChange(e)}
											onChange={(e) => onInputChange(e, "alphabet")}
											InputProps={{
												sx: {
													"&:before": { borderBottomColor: "gray" }, // before focus
													"&:after": { borderBottomColor: "gray" },  // after focus
												},
											}}
											InputLabelProps={{
												sx: { color: 'gray' }, // Optional: if you want the label to be white
											}}
										/>
									</FormControl>
								</FormGroup>
							</div>
							<div style={{ marginTop: "1.5rem" }}>
								{" "}
								<FormGroup>
									<FormControl fullWidth>
										<TextField
											type="contactPerson"
											required
											size="small"
											color="primary"
											label="Contact Person"
											autoFocus={true}
											fullWidth={true}
											variant="standard"

											name="contactPerson"
											id="contactPerson"
											value={contactPerson || ""}
											// onChange={(e) => onInputChange(e)}
											onChange={(e) => onInputChange(e, "alphabet")}
											InputProps={{
												sx: {
													"&:before": { borderBottomColor: "gray" }, // before focus
													"&:after": { borderBottomColor: "gray" },  // after focus
												},
											}}
											InputLabelProps={{
												sx: { color: 'gray' }, // Optional: if you want the label to be white
											}}
										/>
									</FormControl>
								</FormGroup>
							</div>
							<div style={{ marginTop: "1.5rem" }}>
								{" "}
								<FormGroup>
									<FormControl fullWidth>
										<TextField
											autoFocus
											margin="dense"
											// id="name"
											label="Owner Host URL"
											type="name"
											placeholder="https://paymentz.com"
											fullWidth
											variant="standard"
											name="walletOwnerHostURL"
											value={walletOwnerHostURL || ""}
											onChange={(e) => onInputChange(e)}
											InputProps={{
												sx: {
													"&:before": { borderBottomColor: "gray" }, // before focus
													"&:after": { borderBottomColor: "gray" },  // after focus
												},
											}}
											InputLabelProps={{
												sx: { color: 'gray' }, // Optional: if you want the label to be white
											}}
										/>
									</FormControl>
								</FormGroup>
							</div>
							<div style={{ marginTop: "1.5rem" }}>
								{" "}
								<FormGroup>
									<FormControl fullWidth>
										<TextField
											autoFocus
											margin="dense"
											// id="name"
											label="Customer/Merchant Host URL"
											placeholder="https://paymentz.com"
											type="name"
											fullWidth
											variant="standard"
											value={customerMerchantHostURL || ""}
											name="customerMerchantHostURL"
											onChange={(e) => onInputChange(e)}
											InputProps={{
												sx: {
													"&:before": { borderBottomColor: "gray" }, // before focus
													"&:after": { borderBottomColor: "gray" },  // after focus
												},
											}}
											InputLabelProps={{
												sx: { color: 'gray' }, // Optional: if you want the label to be white
											}}
										/>
									</FormControl>
								</FormGroup>
							</div>
							<div style={{ marginTop: "1.5rem" }}>
								{" "}
								<FormGroup>
									<FormControl fullWidth>
										<TextField
											autoFocus
											margin="dense"
											// id="name"
											label="Support URL"
											placeholder="https://paymentz.com"
											type="name"
											fullWidth
											variant="standard"
											value={supportURL || ""}
											name="supportURL"
											onChange={(e) => onInputChange(e)}
											InputProps={{
												sx: {
													"&:before": { borderBottomColor: "gray" }, // before focus
													"&:after": { borderBottomColor: "gray" },  // after focus
												},
											}}
											InputLabelProps={{
												sx: { color: 'gray' }, // Optional: if you want the label to be white
											}}
										/>
									</FormControl>
								</FormGroup>
							</div>

							<div style={{ marginTop: "1.5rem" }}>
								{" "}
								<Typography
									variant="body1"
									align="justify"
									gutterBottom={true}
									style={{ color: "#4f6c8d" }}
								>
									Company Logo Name
								</Typography>
								<FileBase64
									multiple={false}
									name={false}
									id="documentGuard"
									accept=".jpeg, .png, .jpg, .pdf, .csv, .xls, .xlsx"
									onDone={(e) => handleAttachmentsDoc(e, "companyLogo")}
									showUploadList={false}
									value={companyLogoNameImg}
								/>
								{companyLogoName ? companyLogoName : ""}
							</div>

							<div style={{ marginTop: "1.5rem" }}>
								{" "}
								<Typography
									variant="body1"
									align="justify"
									gutterBottom={true}
									style={{ color: "#4f6c8d" }}
								>
									Upload Icon
								</Typography>
								<FileBase64
									multiple={false}
									name={false}
									id="documentGuard1"
									accept=".jpeg, .png, .jpg, .pdf, .csv, .xls, .xlsx"
									onDone={(e) => handleAttachmentsDoc(e, "uploadIcon")}
									showUploadList={false}
									value={uploadIconImg}
								/>
								{uploadIcon ? uploadIcon : ""}
							</div>
							<div style={{ marginTop: "1.5rem" }}>
								{" "}
								<FormGroup>
									<FormControl fullWidth>
										<TextField
											select
											autoFocus
											margin="dense"
											// id="name"
											label="Applying Prepaid Card During SignUp"
											type="name"
											fullWidth
											variant="standard"
											// value={
											// 	applyPrepaidSignUp
											// }
											defaultValue={applyPrepaidSignUp}
											name="applyPrepaidSignUp"
											onChange={(e) => onInputChange(e)}
											InputProps={{
												sx: {
													"&:before": { borderBottomColor: "gray" }, // before focus
													"&:after": { borderBottomColor: "gray" },  // after focus
												},
											}}
											InputLabelProps={{
												sx: { color: 'gray' }, // Optional: if you want the label to be white
											}}
										>
											{/* <MenuItem value="Select Applying Prepaid Card During SignUp">
												Select Applying Prepaid Card During SignUp
											</MenuItem> */}
											<MenuItem value="Y">Y</MenuItem>
											<MenuItem value="N">N</MenuItem>
										</TextField>
									</FormControl>
								</FormGroup>
							</div>
							<div style={{ marginTop: "1.5rem" }}>
								{" "}
								<FormGroup>
									<FormControl fullWidth>
										<TextField
											select
											autoFocus
											margin="dense"
											id="name"
											label="Fraud Check Allowed"
											type="name"
											fullWidth
											variant="standard"
											// value={fraudCheckAllow || "Select Fraud Check Allowed"}
											defaultValue={fraudCheckAllow}
											name="fraudCheckAllow"
											onChange={(e) => onInputChange(e)}
											InputProps={{
												sx: {
													"&:before": { borderBottomColor: "gray" }, // before focus
													"&:after": { borderBottomColor: "gray" },  // after focus
												},
											}}
											InputLabelProps={{
												sx: { color: 'gray' }, // Optional: if you want the label to be white
											}}
										>
											{/* <MenuItem value="Select Fraud Check Allowed">
												Select Fraud Check Allowed
											</MenuItem> */}
											<MenuItem value="Y">Y</MenuItem>
											<MenuItem value="N">N</MenuItem>
										</TextField>
									</FormControl>
								</FormGroup>
							</div>
							<div style={{ marginTop: "1.5rem" }}>
								{" "}
								<FormGroup>
									<FormControl fullWidth>
										<TextField
											select
											autoFocus
											margin="dense"
											id="name"
											label="Email Allowed"
											type="name"
											fullWidth
											variant="standard"
											// value={emailAllow || "Select Email Allowed"}
											defaultValue={emailAllow}
											name="emailAllow"
											onChange={(e) => onInputChange(e)}
											InputProps={{
												sx: {
													"&:before": { borderBottomColor: "gray" }, // before focus
													"&:after": { borderBottomColor: "gray" },  // after focus
												},
											}}
											InputLabelProps={{
												sx: { color: 'gray' }, // Optional: if you want the label to be white
											}}
										>
											{/* <MenuItem value="Select Email Allowed">
												Select Email Allowed
											</MenuItem> */}
											<MenuItem value="Y">Y</MenuItem>
											<MenuItem value="N">N</MenuItem>
										</TextField>
									</FormControl>
								</FormGroup>
							</div>
							<div style={{ marginTop: "1.5rem" }}>
								{" "}
								<FormGroup>
									<FormControl fullWidth>
										<TextField
											select
											autoFocus
											margin="dense"
											id="name"
											label="SMS Allowed"
											type="name"
											fullWidth
											variant="standard"
											// value={smsAllow || "Select SMS Allowed"}
											defaultValue={smsAllow}
											name="smsAllow"
											onChange={(e) => onInputChange(e)}
											InputProps={{
												sx: {
													"&:before": { borderBottomColor: "gray" }, // before focus
													"&:after": { borderBottomColor: "gray" },  // after focus
												},
											}}
											InputLabelProps={{
												sx: { color: 'gray' }, // Optional: if you want the label to be white
											}}
										>
											{/* <MenuItem value="Select SMS Allowed">
												Select SMS Allowed
											</MenuItem> */}
											<MenuItem value="Y">Y</MenuItem>
											<MenuItem value="N">N</MenuItem>
										</TextField>
									</FormControl>
								</FormGroup>
							</div>
							<div style={{ marginTop: "1.5rem" }}>
								{" "}
								<FormGroup>
									<FormControl fullWidth>
										<TextField
											select
											autoFocus
											margin="dense"
											id="name"
											label="Email OTP during Signup Allowed"
											type="name"
											fullWidth
											variant="standard"
											// value={
											// 	emailOTPSignUp ||
											// 	"Select Email OTP during Signup Allowed"
											// }
											defaultValue={emailOTPSignUp}
											name="emailOTPSignUp"
											onChange={(e) => onInputChange(e)}
											InputProps={{
												sx: {
													"&:before": { borderBottomColor: "gray" }, // before focus
													"&:after": { borderBottomColor: "gray" },  // after focus
												},
											}}
											InputLabelProps={{
												sx: { color: 'gray' }, // Optional: if you want the label to be white
											}}
										>
											{/* <MenuItem value="Select Email OTP during Signup Allowed">
												Select Email OTP during Signup Allowed
											</MenuItem> */}
											<MenuItem value="Y">Y</MenuItem>
											<MenuItem value="N">N</MenuItem>
										</TextField>
									</FormControl>
								</FormGroup>
							</div>
							<div style={{ marginTop: "1.5rem" }}>
								{" "}
								<FormGroup>
									<FormControl fullWidth>
										<TextField
											select
											autoFocus
											margin="dense"
											id="name"
											label="SMS OTP during Signup Allowed"
											type="name"
											fullWidth
											variant="standard"
											// value={
											// 	smsOTPSignUp || "Select SMS OTP during Signup Allowed"
											// }
											defaultValue={smsOTPSignUp}
											name="smsOTPSignUp"
											onChange={(e) => onInputChange(e)}
											InputProps={{
												sx: {
													"&:before": { borderBottomColor: "gray" }, // before focus
													"&:after": { borderBottomColor: "gray" },  // after focus
												},
											}}
											InputLabelProps={{
												sx: { color: 'gray' }, // Optional: if you want the label to be white
											}}
										>
											{/* <MenuItem value="Select SMS OTP during Signup Allowed">
												Select SMS OTP during Signup Allowed
											</MenuItem> */}
											<MenuItem value="Y">Y</MenuItem>
											<MenuItem value="N">N</MenuItem>
										</TextField>
									</FormControl>
								</FormGroup>
							</div>
							<div style={{ marginTop: "1.5rem" }}>
								{" "}
								<FormGroup>
									<FormControl fullWidth>
										<TextField
											select
											autoFocus
											margin="dense"
											id="name"
											label="Wallet Required"
											type="name"
											fullWidth
											variant="standard"
											// value={walletRequired || "Select Wallet Required"}
											defaultValue={walletRequired}
											name="walletRequired"
											onChange={(e) => onInputChange(e)}
											InputProps={{
												sx: {
													"&:before": { borderBottomColor: "gray" }, // before focus
													"&:after": { borderBottomColor: "gray" },  // after focus
												},
											}}
											InputLabelProps={{
												sx: { color: 'gray' }, // Optional: if you want the label to be white
											}}
										>
											{/* <MenuItem value="Select Wallet Required">
												Select Wallet Required
											</MenuItem> */}
											<MenuItem value="Y">Y</MenuItem>
											<MenuItem value="N">N</MenuItem>
										</TextField>
									</FormControl>
								</FormGroup>
							</div>
							<div style={{ marginTop: "1.5rem" }}>
								{" "}
								<FormGroup>
									<FormControl fullWidth>
										<TextField
											select
											autoFocus
											margin="dense"
											id="name"
											label="Two Factor Google Authenticator"
											type="name"
											fullWidth
											variant="standard"
											// value={walletRequired || "Select Wallet Required"}
											// defaultValue={walletRequired}
											// name="walletRequired"
											// onChange={(e) => onInputChange(e)}
											name="twoFactorAuthen"
											value={twoFactorAuthen || ""}
											// onChange={(e) => onInputChange(e)}
											onChange={handleChange}
											InputProps={{
												sx: {
													"&:before": { borderBottomColor: "gray" }, // before focus
													"&:after": { borderBottomColor: "gray" },  // after focus
												},
											}}
											InputLabelProps={{
												sx: { color: 'gray' }, // Optional: if you want the label to be white
											}}
										>
											{/* <MenuItem value="Select Wallet Required">
												Select Wallet Required
											</MenuItem> */}
											<MenuItem value="Y">Y</MenuItem>
											<MenuItem value="N">N</MenuItem>
										</TextField>
									</FormControl>
								</FormGroup>
							</div>
							<div style={{ marginTop: "1.5rem" }}>
								{" "}
								<FormGroup>
									<FormControl fullWidth>
										<TextField
											select
											autoFocus
											margin="dense"
											id="name"
											label="Voucher Required"
											type="name"
											fullWidth
											variant="standard"
											// value={voucherRequired || "Select Voucher Required"}
											defaultValue={voucherRequired}
											name="voucherRequired"
											onChange={(e) => onInputChange(e)}
											InputProps={{
												sx: {
													"&:before": { borderBottomColor: "gray" }, // before focus
													"&:after": { borderBottomColor: "gray" },  // after focus
												},
											}}
											InputLabelProps={{
												sx: { color: 'gray' }, // Optional: if you want the label to be white
											}}
										>
											{/* <MenuItem value="Select Voucher Required">
												Select Voucher Required
											</MenuItem> */}
											<MenuItem value="Y">Y</MenuItem>
											<MenuItem value="N">N</MenuItem>
										</TextField>
									</FormControl>
								</FormGroup>
							</div>
							<div>
								{voucherRequired == "Y" ? (
									<>
										<div style={{ marginTop: "1.5rem" }}>
											{" "}
											{/* <FormGroup>
													<FormControl fullWidth>
														<TextField
															autoFocus
															margin="dense"
															id="name"
															label="Voucher Expiry Days"
															type="text"
															fullWidth
															variant="standard"
															// value={voucherRequired || "Select Voucher Required"}
															defaultValue={expiryDays}
															name="voucherExpiryDays"
															onChange={(e) => onInputChange(e)}
														// onChange={(e) => onInputChange(e, "number")}
														>
														</TextField>
													</FormControl>
												</FormGroup> */}
											<FormGroup>
												<FormControl fullWidth>
													<TextField
														size="small"
														color="primary"
														autoFocus={true}
														label="Voucher Expiry Days"
														variant="standard"
														fullWidth={true}
														name="expiryDays"
														value={expiryDays || ""}
														// onChange={(e) => onInputChange(e)}
														onChange={(e) => onInputChange(e, "number")}
														InputProps={{
															sx: {
																"&:before": { borderBottomColor: "gray" }, // before focus
																"&:after": { borderBottomColor: "gray" },  // after focus
															},
														}}
														InputLabelProps={{
															sx: { color: 'gray' }, // Optional: if you want the label to be white
														}}
													/>
												</FormControl>
											</FormGroup>
										</div>
										<div style={{ marginTop: "1.5rem" }}>
											{" "}
											<FormGroup>
												<FormControl fullWidth>
													<TextField
														select
														autoFocus
														margin="dense"
														id="name"
														label="Allow Refund"
														type="name"
														fullWidth
														variant="standard"
														// value={voucherRequired || "Select Voucher Required"}
														defaultValue={allowRefund}
														name="allowRefund"
														onChange={(e) => onInputChange(e)}
														InputProps={{
															sx: {
																"&:before": { borderBottomColor: "gray" }, // before focus
																"&:after": { borderBottomColor: "gray" },  // after focus
															},
														}}
														InputLabelProps={{
															sx: { color: 'gray' }, // Optional: if you want the label to be white
														}}
													>
														{/* <MenuItem value="Select Voucher Required">
												Select Voucher Required
											</MenuItem> */}
														<MenuItem value="Y">Y</MenuItem>
														<MenuItem value="N">N</MenuItem>
													</TextField>
												</FormControl>
											</FormGroup>
										</div>
										<div style={{ marginTop: "1.5rem" }}>
											{" "}
											<FormGroup>
												<FormControl fullWidth>
													<TextField
														select
														autoFocus
														margin="dense"
														id="name"
														label="Custom Amount Allowed"
														type="name"
														fullWidth
														variant="standard"
														// value={voucherRequired || "Select Voucher Required"}
														defaultValue={isCustomAmtAllowed}
														name="customAmountAllowed"
														onChange={(e) => onInputChange(e)}
														InputProps={{
															sx: {
																"&:before": { borderBottomColor: "gray" }, // before focus
																"&:after": { borderBottomColor: "gray" },  // after focus
															},
														}}
														InputLabelProps={{
															sx: { color: 'gray' }, // Optional: if you want the label to be white
														}}
													>
														{/* <MenuItem value="Select Voucher Required">
												Select Voucher Required
											</MenuItem> */}
														<MenuItem value="Y">Y</MenuItem>
														<MenuItem value="N">N</MenuItem>
													</TextField>
												</FormControl>
											</FormGroup>
										</div>
										<div style={{ marginTop: "1.5rem" }}>
											{" "}
											<FormGroup>
												<FormControl fullWidth>
													<TextField
														disabled
														autoFocus
														margin="dense"
														id="name"
														label="Minimum Voucher Amount"
														type="name"
														fullWidth
														variant="standard"
														// value={voucherRequired || "Select Voucher Required"}
														defaultValue={minVoucherAmt}
														name="minimumVoucherAmount"
														onChange={(e) => onInputChange(e)}
														InputProps={{
															sx: {
																"&:before": { borderBottomColor: "gray" }, // before focus
																"&:after": { borderBottomColor: "gray" },  // after focus
															},
														}}
														InputLabelProps={{
															sx: { color: 'gray' }, // Optional: if you want the label to be white
														}}
													>
														{/* <MenuItem value="Select Voucher Required">
												Select Voucher Required
											</MenuItem> */}
														<MenuItem value="Y">Y</MenuItem>
														<MenuItem value="N">N</MenuItem>
													</TextField>
												</FormControl>
											</FormGroup>
										</div>
									</>
								) : (
									""
								)}
							</div>
							<div style={{ marginTop: "1.5rem" }}>
								{" "}
								<FormGroup>
									<FormControl fullWidth>
										<TextField
											select
											autoFocus
											margin="dense"
											id="name"
											label="Template"
											type="name"
											fullWidth
											variant="standard"
											// value={template || "Select Template"}
											defaultValue={template}
											name="template"
											onChange={(e) => onInputChange(e)}
											InputProps={{
												sx: {
													"&:before": { borderBottomColor: "gray" }, // before focus
													"&:after": { borderBottomColor: "gray" },  // after focus
												},
											}}
											InputLabelProps={{
												sx: { color: 'gray' }, // Optional: if you want the label to be white
											}}
										>
											{/* <MenuItem value="Select Template">
												Select Template
											</MenuItem> */}
											<MenuItem value="Y">Y</MenuItem>
											<MenuItem value="N">N</MenuItem>
										</TextField>
									</FormControl>
								</FormGroup>
							</div>
							<div style={{ marginTop: "1.5rem" }}>
								{" "}
								<FormGroup>
									<FormControl fullWidth>
										<TextField
											select
											autoFocus
											margin="dense"
											id="name"
											label="Select Theme"
											type="name"
											fullWidth
											variant="standard"
											value={currentTheme || "Select Theme"}
											name="currentTheme"
											onChange={(e) => onInputChange(e)}
											InputProps={{
												sx: {
													"&:before": { borderBottomColor: "gray" }, // before focus
													"&:after": { borderBottomColor: "gray" },  // after focus
												},
											}}
											InputLabelProps={{
												sx: { color: 'gray' }, // Optional: if you want the label to be white
											}}
										>
											<MenuItem value="Select Theme">Select Theme</MenuItem>
											{themeList.data.themeList &&
												themeList.data.themeList.map((x) => (
													<MenuItem value={x}>{x}</MenuItem>
												))}
										</TextField>
									</FormControl>
								</FormGroup>
							</div>
							<div style={{ marginTop: "1.5rem" }}>
								{" "}
								<FormGroup>
									<FormControl fullWidth>
										<TextField
											select
											margin="dense"
											id="name"
											label="Invoice Required"
											type="name"
											fullWidth
											variant="standard"
											// value={emailAllow || "Select Email Allowed"}
											defaultValue={emailAllow}
											name="invoiceRequired"
											onChange={(e) => onInputChange(e)}
											InputProps={{
												sx: {
													"&:before": { borderBottomColor: "gray" }, // before focus
													"&:after": { borderBottomColor: "gray" },  // after focus
												},
											}}
											InputLabelProps={{
												sx: { color: 'gray' }, // Optional: if you want the label to be white
											}}
										>
											{/* <MenuItem value="Select Email Allowed">
												Select Email Allowed
											</MenuItem> */}
											<MenuItem value="Y">Y</MenuItem>
											<MenuItem value="N">N</MenuItem>
										</TextField>
									</FormControl>
								</FormGroup>
							</div>
							<div style={{ marginTop: "1.5rem" }}>
								{" "}
								<FormGroup>
									<FormControl fullWidth>
										<TextField
											select
											margin="dense"
											id="name"
											label="Open Banking Required"
											type="name"
											fullWidth
											variant="standard"
											// value={emailAllow || "Select Email Allowed"}
											defaultValue={emailAllow}
											name="openBankingRequired"
											onChange={(e) => onInputChange(e)}
											InputProps={{
												sx: {
													"&:before": { borderBottomColor: "gray" }, // before focus
													"&:after": { borderBottomColor: "gray" },  // after focus
												},
											}}
											InputLabelProps={{
												sx: { color: 'gray' }, // Optional: if you want the label to be white
											}}
										>
											{/* <MenuItem value="Select Email Allowed">
												Select Email Allowed
											</MenuItem> */}
											<MenuItem value="Y">Y</MenuItem>
											<MenuItem value="N">N</MenuItem>
										</TextField>
									</FormControl>
								</FormGroup>
							</div>
							<div style={{ marginTop: "1.5rem" }}>
								{" "}
								<FormGroup>
									<FormControl fullWidth>
										<TextField
											type="url"
											size="small"
											color="primary"
											label="Twitter URL"
											variant="standard"

											autoFocus={true}
											fullWidth={true}
											name="twitterUrl"
											id="twitterUrl"
											value={twitterUrl || ""}
											// onChange={(e) => onInputChange(e)}
											onChange={(e) => onInputChange(e)}
											InputProps={{
												sx: {
													"&:before": { borderBottomColor: "gray" }, // before focus
													"&:after": { borderBottomColor: "gray" },  // after focus
												},
											}}
											InputLabelProps={{
												sx: { color: 'gray' }, // Optional: if you want the label to be white
											}}
										/>
									</FormControl>
								</FormGroup>
							</div>
							<div style={{ marginTop: "1.5rem" }}>
								{" "}
								<FormGroup>
									<FormControl fullWidth>
										<TextField
											type="url"
											size="small"
											color="primary"
											label="Instagram URL"
											variant="standard"

											autoFocus={true}
											fullWidth={true}
											name="instagramUrl"
											id="instagramUrl"
											value={instagramUrl || ""}
											// onChange={(e) => onInputChange(e)}
											onChange={(e) => onInputChange(e)}
											InputProps={{
												sx: {
													"&:before": { borderBottomColor: "gray" }, // before focus
													"&:after": { borderBottomColor: "gray" },  // after focus
												},
											}}
											InputLabelProps={{
												sx: { color: 'gray' }, // Optional: if you want the label to be white
											}}
										/>
									</FormControl>
								</FormGroup>
							</div>
							<div style={{ marginTop: "1.5rem" }}>
								{" "}
								<FormGroup>
									<FormControl fullWidth>
										<TextField
											type="url"
											size="small"
											color="primary"
											label="Facebook URL"
											variant="standard"

											autoFocus={true}
											fullWidth={true}
											name="facebookUrl"
											id="facebookUrl"
											value={facebookUrl || ""}
											// onChange={(e) => onInputChange(e)}
											onChange={(e) => onInputChange(e)}
											InputProps={{
												sx: {
													"&:before": { borderBottomColor: "gray" }, // before focus
													"&:after": { borderBottomColor: "gray" },  // after focus
												},
											}}
											InputLabelProps={{
												sx: { color: 'gray' }, // Optional: if you want the label to be white
											}}
										/>
									</FormControl>
								</FormGroup>
							</div>
							<div style={{ marginTop: "1.5rem" }}>
								{" "}
								<FormGroup>
									<FormControl fullWidth>

										<Box style={{ marginTop: "12px" }}>
											<Typography>Sign Up Consent</Typography>
											<textarea id="w3review" rows="5" cols="86"
												className="textAreaField"
												// color="primary"
												autoFocus={true}
												name="getSignUpConsent"
												value={getSignUpConsent || ""}
												// onChange={(e) => onInputChange(e)}
												onChange={handleChange}
											>
											</textarea></Box>
									</FormControl>
								</FormGroup>
							</div>
							<div style={{ marginTop: "1.5rem" }}>
								{" "}
								<FormGroup>
									<FormControl fullWidth>

										<Box style={{ marginTop: "9px" }}>
											<Typography>Transaction Consent</Typography>
											<textarea id="w3review" rows="5" cols="86"
												color="primary"
												// autoFocus={true}
												className="textAreaField"
												name="getTransactionConsent"
												value={getTransactionConsent || ""}
												// onChange={(e) => onInputChange(e)}
												onChange={handleChange}



											>

											</textarea></Box>
									</FormControl>
								</FormGroup>
							</div>
							{/* Wallet Owner Host URL, Customer/Merchant Host URL, Support URL */}

							<div className="text-center" style={{ marginTop: "2.5rem" }}>
								<Button
									style={{
										// marginLeft: "0.7rem",
										backgroundColor: "#00b9f5",
										color: "white"
									}}
									variant="contained"
									// color="primary"
									onClick={submitClick}
								>
									Submit
								</Button>
							</div>
						</Grid>

						<Grid item xs={12} md={2} lg={2}></Grid>
					</Grid>
				</Card>
			</Layout>

			{addOrUpdateCreateWalletArray.status == "success" && (
				<div>
					<Dialog open={notificationOpen} onClose={handleNoticationClose}>
						<DialogContent
							className="text-center"
							style={{ backgroundColor: "#00b9f51c" }}
						>
							<img src={success} alt="" width="100px" className="my-2" />
						</DialogContent>
						<DialogContent>
							<h4
								style={{ margin: "0", textAlign: "center", fontSize: "15px" }}
							>
								{addOrUpdateCreateWalletArray.description}
							</h4>
						</DialogContent>
						<DialogActions style={{ justifyContent: "center" }}>
							<Button
								style={{
									margin: "10px 0",
									backgroundColor: "#00b9f5",
									color: "white"
								}}
								variant="contained"
								onClick={handleNoticationClose}
							>
								Ok
							</Button>
						</DialogActions>
					</Dialog>
				</div>
			)}

			{addOrUpdateCreateWalletArray.status == "failed" && (
				<div>
					<Dialog open={notificationOpen} onClose={handleNoticationClose}>
						<DialogContent
							className="text-center"
							style={{ backgroundColor: "#00b9f51c" }}
						>
							<img src={failed} alt="" width="100px" className="my-2" />
						</DialogContent>
						<DialogContent>
							<h4
								style={{ margin: "0", textAlign: "center", fontSize: "15px" }}
							>
								{addOrUpdateCreateWalletArray.description}
							</h4>
						</DialogContent>
						<DialogActions style={{ justifyContent: "center" }}>
							<Button
								style={{
									margin: "10px 0",
									backgroundColor: "#00b9f5",
									color: "white"
								}}
								variant="contained"
								onClick={handleNoticationClose}
							>
								Ok
							</Button>
						</DialogActions>
					</Dialog>
				</div>
			)}
		</>
	);
};

export default AdminAddWalletOwner;
